import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import { supabase } from "../supabaseClient";
import { Button, Dropdown, Input, Tab } from "semantic-ui-react";
import Schedule from "../components/Schedule";

const User = () => {
  const panes = [
    {
      menuItem: "User Info",
      render: () => (
        <Tab.Pane attached={false}>
          <UserForm />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Scheduling",
      render: () => (
        <Tab.Pane attached={false}>
          <Schedule />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Access",
      render: () => <Tab.Pane attached={false}>Tab 3 Content 34</Tab.Pane>,
    },
  ];

  return (
    <div
    style={{
        margin: "0 auto",
        maxWidth: 1300,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "80vh",
      }}
    >
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
};

export default User;


const UserForm = () => {
  const [state,setState] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const history = useHistory();

  const [form,setForm] = useState({
    fullName: query.get("fullName") || "",
    email: query.get("email") || "",
    country: query.get("country") || "",
    type: query.get("type") || "",
    interested: [],
    purpose:"",
    source:"",
    firstName:query.get("name") || "",
    lastName:query.get("lastName") || "",
  });

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

console.log(form)
  const handleForm = async () => {
    setState(true)
    try {
      const { data, error } = await supabase
        .from("email_customer")
        .insert([
          {
            fullName: form.name,
            email: form.email,
            country: form.country,
            type: form.type,
            purpose:form.purpose,
            source:form.source,
            interested: form.interested,
            firstName:form.firstName,
            lastName:form.lastName
          },
        ]);

      if (data) {
        setState(false);
        setForm({fullName:"",email:"",type:"",interested:[]})
        // await supabase
        //   .from("emailLeads_customer")
        //   .update({ isBetaRegistered: "true" })
        //   .eq("email", form.email);
        alert("Submitted Successfully")
      }
      if (error) throw error;
    } catch (e) {
      alert(e.message);
      setState(false);
    }
  };

  useEffect(() => {
    if (query.get("email")) {
      setTimeout(() => handleForm(),1500);
    }
  }, []);

  const countryOptions = [
    { key: "India", value: "India", text: "India" },
    { key: "USA", value: "USA", text: "USA" },
    { key: "Canada", value: "Canada", text: "Canada" },
    { key: "Australia", value: "Australia", text: "Australia" },
    { key: "Russia", value: "Russia", text: "Russia" },
    { key: "Germany", value: "Germany", text: "Germany" },
  ];

  const typeOptions = [
    { key: "Professional", value: "Professional", text: "Professional" },
    {
      key: "Investor/Trader",
      value: "Investor/Trader",
      text: "Investor/Trader",
    },
    {
      key: "Charted Accountant",
      value: "Charted Accountant",
      text: "Charted Accountant",
    },
    { key: "CPA", value: "CPA", text: "CPA" },
    { key: "Auditor", value: "Auditor", text: "Auditor" },
    { key: "Fund Manager", value: "Fund Manager", text: "Fund Manager" },
    {
      key: "Corporate/Enterprise",
      value: "Corporate/Enterprise",
      text: "Corporate/Enterprise",
    },
    { key: "Other", value: "Other", text: "Other" },
  ];

  const interestedOptions = [
    
    {
      key: "Taxation Solution",
      value: "Taxation Solution",
      text: "Taxation Solution",
    },
    {
      key: "Profession Solution",
      value: "Profession Solution",
      text: "Profession Solution",
    },
    {
      key: "Catax Enterprise",
      value: "Catax Enterprise",
      text: "Catax Enterprise",
    },
    { key: "Affiliate Program", value: "Affiliate", text: "Affiliate Program" },
    {
      key: "Catax Analytics",
      value: "Catax Analytics",
      text: "Catax Analytics",
    },
  ];

  return (
    <>
    
          <div
            style={{
              fontSize: 28,
              fontWeight: 700,
              marginBottom: 50,
              textAlign: "left",
            }}
          >
            Tell us About your home.
          </div>
          <div
            style={{
              display:"flex",
              flexWrap:"wrap",
              justifyContent:"space-between",
              textAlign: "left",
              maxWidth: 1000,
              
            }}
          >
            <div style={{ maxWidth:450}}>
              <div>
                <span style={{ fontWeight: 700, fontSize: 20 }}>Address</span>
                <br />
                <span style={{ fontSize: 18, lineHeight: 1.6 }}>
                  Don't worry,your information is private and we will not share
                  this info with anyone outside Superhost!
                </span>
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: 22,
                  color: "#a64d79",
                  marginTop: 25,
                  marginBottom: 40,
                }}
              >
                Customer Information
              </div>
              <table
                style={{
                  color: "#a64d79",
                  width: "100%",
                }}
              >
                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                    marginBottom: "80px !important",
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px 0",
                    }}
                  >
                    <th>First Name</th>
                    <td>
                      <Input
                        type="text"
                        fluid
                        style={{ width: "100%" }}
                        onChange={onChange}
                        name="firstName"
                        value={form.firstName}
                      />
                    </td>
                  </td>
                </tr>
                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                    marginBottom: "80px !important",
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px 0",
                    }}
                  >
                    <th>Last Name</th>
                    <td>
                      <Input
                        type="text"
                        fluid
                        style={{ width: "100%" }}
                        onChange={onChange}
                        name="lastName"
                        value={form.lastName}
                      />
                    </td>
                  </td>
                </tr>

                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px 0",
                    }}
                  >
                    <th>Email</th>
                    <td>
                      <Input
                        type="text"
                        fluid
                        onChange={onChange}
                        name="email"
                        value={form.email}

                      />
                    </td>
                  </td>
                </tr>


                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px 0",
                    }}
                  >
                    <th>Purpose</th>
                    <td>
                      <Input
                        type="text"
                        fluid
                        onChange={onChange}
                        name="purpose"
                        value={form.purpose}

                      />
                    </td>
                  </td>
                </tr>


                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px 0",
                    }}
                  >
                    <th>Source</th>
                    <td>
                      <Input
                        type="text"
                        fluid
                        onChange={onChange}
                        name="source"
                        value={form.source}

                      />
                    </td>
                  </td>
                </tr>

                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",

                      margin: "10px 0",
                    }}
                  >
                    <th>Country</th>
                    <Dropdown
                      placeholder="Select Country"
                      fluid
                      selection
                      options={countryOptions}
                      onChange={(e, { value }) =>setForm({ ...form, country: value })}
                      name="country"
                      value={form.country}

                      style={{maxWidth:350}}
                    />
                  </td>
                </tr>

                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px 0",
                    }}
                  >
                    <th>I am</th>

                    <Dropdown
                      placeholder="Select One"
                      fluid
                      selection
                      options={typeOptions}
                      onChange={(e, { value }) =>
                      setForm({ ...form, type: value })
                    }
                    value={form.type}

                    style={{maxWidth:350}}
                    />
                  </td>
                </tr>

                <tr
                  style={{
                    textAlign: "left",
                    marginRight: 20,
                  }}
                >
                  <td
                    style={{
                      display: "flex",
                      flexDirection:"column",
                      margin: "10px 0",
                    }}
                  >
                    <th>Interested in</th>
                    <Dropdown
                      placeholder="Select One"
                      fluid
                      multiple
                      selection
                      options={interestedOptions}
                      onChange={(e, { value }) =>
                      setForm({ ...form, interested: value })

                    }
                    value={form.interested}
                    
                    style={{maxWidth:350}}

                    />
                  </td>
                </tr>
              </table>

              <Button
                style={{
                  outline: 0,
                  border: 0,
                  background: "#a64d79",
                  width: 200,
                  padding: 10,
                  color: "#fff",
                  fontSize: 18,
                  marginTop: 40,
                  borderRadius: "3px",
                }}
                onClick={handleForm}
                loading={state}
              >
                Submit
              </Button>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: 400,
                  alignItems: "flex-start",
                  fontSize: 18,
                  lineHeight: 1.6,
                }}
              >
                <span
                  style={{ fontWeight: 700, fontSize: 20, marginBottom: 10 }}
                >
                  Need help?
                </span>
                <span>
                  We will be more than happy to assest you in fill the form.
                  Please contact one of our superhost manager.
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: 400,
                  alignItems: "flex-start",
                  marginTop: 20,
                  fontSize: 18,
                  lineHeight: 1.6,
                }}
              >
                <span
                  style={{ fontWeight: 700, fontSize: 20, marginBottom: 10 }}
                >
                  Your Home
                </span>
                <span>950 Mason St,San Francisco, CA 34108,United States</span>
              </div>
            </div>
          </div>
        </>

  );
};
